export const ROUTES = {
  RunModel: `/v1/models/run`,
};
